import _ from 'lodash';
import { TRACKING, SUPPORTED_CHAT_TOOLS } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';

export const toggleNotificationsForTeam = async (
  settings,
  setSettings,
  updateSetting,
  isOrgSettings,
  team,
  value,
  chatTool = _.keys(SUPPORTED_CHAT_TOOLS)[0]
) => {
  const teamSettings = settings[team.id];

  try {
    await updateSetting('teamIsNotificationsEnabled', value, 'team', team.id);
    setSettings({
      ...settings,
      [team.id]: {
        ...teamSettings,
        isNotificationEnabled: value
      }
    });

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.SETTINGS,
      page_tab: isOrgSettings
        ? TRACKING.PAGE_TABS[chatTool]
        : TRACKING.PAGE_TABS[`TEAM_${chatTool}`],
      click_type: value
        ? isOrgSettings
          ? TRACKING.CLICK.OPTIN
          : TRACKING.CLICK.TURN_ON_NOTIFICATIONS
        : isOrgSettings
        ? TRACKING.CLICK.OPTOUT
        : TRACKING.CLICK.TURN_OFF_NOTIFICATIONS,
      ...(isOrgSettings && { team_name: team.name })
    });
  } catch (e) {
    return false;
  }
};
